export class CartHelper {

	static calculateCartNet = cart => cart.items.map(i => CartHelper.calculateItemNet(i)).reduce((a, b) => a + b, 0)

	static calculateItemNet = item => item.qty * CartHelper._getItemNet(item)

	static calculateProductNet = item => item.qty * (item.variant ? item.variant.net : item.product.net)

	static calculateExtrasNet = item => item.qty * item.extraCategories.map(c => CartHelper._getExtrasCategoryNet(c)).reduce((a, b) => a + b, 0)

	static _getItemNet = item => item.extraCategories.map(c => CartHelper._getExtrasCategoryNet(c)).reduce((a, b) => a + b, item.variant ? item.variant.net : item.product.net)

	static _getExtrasCategoryNet = extraCategory => extraCategory.extraOptions.map(o => o.net).reduce((a, b) => a + b, 0)

	static calculateCartTax = cart => cart.items.map(i => CartHelper.calculateItemTax(i)).reduce((a, b) => a + b, 0)

	static calculateItemTax = item => item.qty * CartHelper._getItemTax(item)

	static calculateProductTax = item => item.qty * (item.variant ? item.variant.tax : item.product.tax)

	static calculateExtrasTax = item => item.qty * item.extraCategories.map(c => CartHelper._getExtrasCategoryTax(c)).reduce((a, b) => a + b, 0)

	static _getItemTax = item => item.extraCategories.map(c => CartHelper._getExtrasCategoryTax(c)).reduce((a, b) => a + b, item.variant ? item.variant.tax : item.product.tax)

	static _getExtrasCategoryTax = extraCategory => extraCategory.extraOptions.map(o => o.tax).reduce((a, b) => a + b, 0)

	static formatPrice = number => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(number)

	static getUuid = () => {
		// Replace random crypto.randomUUID()
		const array = new Uint32Array(4)
		crypto.getRandomValues(array)
		const hex = array[0].toString(16) + array[1].toString(16) + array[2].toString(16) + array[3].toString(16)
		const uuid = hex.substring(0, 8) + '-' + hex.substring(8, 12) + '-' + hex.substring(12, 16) + '-' + hex.substring(16, 20) + '-' + hex.substring(20, 32)
		return uuid
	}

}